import React from "react"
import { QuotationmarkIcon } from "components/page-components/Icons/medium"
import { ArticleContentComponentContainer } from "../utils"

export const Quote = ({ content, author }) => {
  return (
    <ArticleContentComponentContainer>
      <div className="ml-6 my-5">
        <div style={{ position: "relative" }}>
          <p className="title is-3 mb-4">{content}</p>
          <div
            className=""
            style={{ position: "absolute", bottom: -15, left: -45 }}
          >
            <QuotationmarkIcon {...{ size: 0.7 }} />
          </div>
        </div>
        {!!author ? <p>- {author}</p> : null}
      </div>
    </ArticleContentComponentContainer>
  )
}
